// extracted by mini-css-extract-plugin
export default {"wrapper":"ShiftManage_wrapper__Mz3zf","tips":"ShiftManage_tips__0vFdw"};